// Added by Sejune Oh on 2020-02-25
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React from 'react'
import { createStyles,  makeStyles } from '@material-ui/core'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
import { LCSStatisticStyleTypes } from '@/components/worklist/WebComponents/LCSStatisticWrapper'
export interface RadsScorePercentageViewProps {
  /** RADS Score */
  score: string
  /** RADS Score의 비율 */
  rate: number
  /** RADS Score Panel의 색상 */
  panelColor: string
  /** WC용 Styles  */
  classes?: LCSStatisticStyleTypes
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/**
 * RADS Score 와 차지하는 비율을 보여주는 UI입니다.
 */
const RadsScorePercentageView = ({
  score,
  rate,
  panelColor,
  classes: webComponentClassses,
  ...rest
}: RadsScorePercentageViewProps) => {
  const classes = webComponentClassses
    ? webComponentClassses['radsscorepercentageview']
    : makeStyles(() => createStyles({ ...customStyles }))()

  return (
    <div className={classes.wrapper}>
      <span className={classes.firstCol}>
        <span style={{ backgroundColor: panelColor }}>{score}</span>
      </span>
      <span className={classes.secondCol}>
        {rate} <small>%</small>
      </span>
    </div>
  )
}

export const customStyles: Record<string, any> = {
  wrapper: {
    height: '17px',
    color: '#fff',
    display: 'flex',
    '& > span': {
      display: 'flex',
      alignItems: 'center',
    },
  },
  firstCol: {
    width: '22px',
    fontSize: '10px',
    justifyContent: 'center',
    marginLeft: '2px',
    fontWeight: 'bold',
    '&>span': {
      border: '1px solid #000',
      color: '#000',
      width: '100%',
      textAlign: 'center',
    },
  },
  secondCol: {
    width: '38px',
    fontSize: '12px',
    justifyContent: 'flex-end',
    '&>small': {
      fontSize: '10px',
    },
  },
}

export default RadsScorePercentageView
